import { z } from 'zod'

// Field names (source_type, why_it_matters) intentionally stay snake_case: this shape flows directly into/out of
// the LLM prompt context (packages/campaign's old seedExemplarSchema), unlike the rest of our camelCase rows.
export const SeedExemplarSchema = z.object({
  url: z.string().url(),
  source_type: z.enum(['other_creator', 'artist_own_history', 'aspirational']),
  why_it_matters: z.string().max(500).optional()
})

export type SeedExemplar = z.infer<typeof SeedExemplarSchema>

export const SeedExemplarsArraySchema = z.array(SeedExemplarSchema).max(5)
